import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private readonly ALLOWED_PLATFORMS = ['BACKOFFICE_ADMIN', 'BACKOFFICE_COMPANY'];

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(): Observable<boolean> {
    const jwtToken = localStorage.getItem('jwtToken');

    if (!jwtToken) {
      return this.redirectToLogin();
    }

    return this.authService.loadUser().pipe(
      map((response: { data: any }) => {
        const { plateform } = response.data;
        const isAuthorized = this.ALLOWED_PLATFORMS.includes(plateform);

        if (!isAuthorized) {
          this.router.navigate(['/login']);
          return false; // ✅ toujours boolean ici
        }

        return true;
      }),
      catchError((error) => {
        if (error.status === 402) {
          return of(true);
        }
        return this.redirectToLogin();
      })
    );
  }

  private redirectToLogin(): Observable<boolean> {
    this.router.navigate(['/login']);
    return of(false);
  }
}
